<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>
<h1>{{ dispTitle }}</h1> 

<!-- Select what to search -->
<mat-card class="cur-card" *ngIf="dispFlg">
  <mat-card-content>
    <div *ngIf="incCtrFlg">
      <form [formGroup]="registContractForm">
        <app-sgkb708d-ctrinfo
          (selectedType)="setValue($event)"
          [mode]="mode" [incCtrSearchresult]="incCtrSearchresult" [codeConversionMstMap]="codeConversionMstMap"
          [keiyakuTantouBushoList]="keiyakuTantouBushoList">
        </app-sgkb708d-ctrinfo> 
      </form>
    </div>
  </mat-card-content>
</mat-card>

<mat-card class="cur-card" *ngIf="dispFlg">
  <mat-card-header>
    <mat-card-title>包括契約需給契約一覧</mat-card-title>
  </mat-card-header>
  <div *ngIf="incCtrFlg">
    <form [formGroup]="jyukyuListForm">
      <app-sgkb708d-inclutagsupdemandctr (setMessageEvent)="pushSgAriaMessage($event)" (dataSourceChange)="onDataSourceChanged($event)" 
        (clearMessageEvent)="clearMessage()"
        [indisabledBotton]="eventData" [mode]="mode" [incCtrSearchresult]="incCtrSearchresult"
        [codeConversionMstMap]="codeConversionMstMap">
      </app-sgkb708d-inclutagsupdemandctr> 
    </form>
  </div>
</mat-card>

<mat-card class="cur-card" *ngIf="dispFlg && appliInfoDispFlg">
  <mat-card-content>
    <div *ngIf="incCtrFlg">
      <form [formGroup]="appliInfoForm">
        <app-sgkb708d-appliinfo
          [mode]="mode" [incCtrSearchresult]="incCtrSearchresult">
        </app-sgkb708d-appliinfo> 
      </form>
    </div>
  </mat-card-content>
</mat-card>

<mat-card class="cur-card" *ngIf="dispFlg">
  <mat-card-content>
    <div *ngIf="incCtrFlg">
      <form [formGroup]="buttonForm">
        <app-sgkb708d-button [mode]="mode" [incCtrSearchresult]="incCtrSearchresult"
          [registContractForm]="registContractForm" [dataSource]="dataSource"
          [keiyakuTantouBushoList]="keiyakuTantouBushoList">
        </app-sgkb708d-button> 
      </form>
    </div>
  </mat-card-content>
</mat-card>



